import { ButtonGroupProps } from 'react-multi-carousel'
import { common } from '@ocean/ui'
import { ArrowsContainer, ArrowButton } from './SlideshowArrows.styled'

const { Icon } = common

const SlideshowArrows: React.FC<ButtonGroupProps> = ({ next, previous, carouselState }) => {
  const { totalItems = 0, currentSlide = 0 } = carouselState || {}
  const isFirstSlide = currentSlide === 0
  const isLastSlide = currentSlide === totalItems - 1
  return (
    <ArrowsContainer className='react-multi-carousel-custom-buttons'>
      <ArrowButton isPrevious isActive={!isFirstSlide} onClick={previous}>
        <Icon icon='arrow' />
      </ArrowButton>
      <ArrowButton isNext isActive={!isLastSlide} onClick={next}>
        <Icon icon='arrow' />
      </ArrowButton>
    </ArrowsContainer>
  )
}

export default SlideshowArrows
